<template>
  <div class="help-container">
    <div class="help-list">
      <router-link to="/data_public/index">
        <el-card shadow="hover" class="help-box">
          <div class="bg">
            <img src="@/assets/icon_sjgl.png" alt="" />
          </div>
          <div>
            <div class="title">数据概览</div>
            <div class="content">快速查看本网站提供的全部数据集、数据项</div>
          </div>
        </el-card>
      </router-link>
      <router-link to="/develop/detail">
        <el-card shadow="hover" class="help-box">
          <div class="bg">
            <img src="@/assets/icon_sjgl.png" alt="" />
          </div>
          <div>
            <div class="title">新手指南</div>
            <div class="content">为访者提供数据获取利用的指引和资讯</div>
          </div>
        </el-card>
      </router-link>
      <router-link to="/interface/index">
        <el-card shadow="hover" class="help-box">
          <div class="bg">
            <img src="@/assets/icon_jksq.png" alt="" />
          </div>
          <div>
            <div class="title">接口申请</div>
            <div class="content">了解动态数据接口申请的必备条件与申请流</div>
          </div>
        </el-card>
      </router-link>
      <router-link to="/develop/detail">
        <el-card shadow="hover" class="help-box">
          <div class="bg">
            <img src="@/assets/icon_yytj.png" alt="" />
          </div>
          <div>
            <div class="title">应用提交</div>
            <div class="content">为利用开放数据开发的应用 提供推广通道</div>
          </div>
        </el-card>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        name: "",
        type: "",
        mobile: "",
        email: "",
        content: "",
        title: ""
      }
    };
  },

  methods: {
    onSubmit() {
      console.log("submit!");
    },
    reset() {
      this.form = {
        name: "",
        type: "",
        mobile: "",
        email: "",
        content: "",
        title: ""
      };
      this.$refs["form"].resetFields();
    }
  }
};
</script>

<style lang="scss" scoped>
.help-container {
  min-width: 1200px;
  .el-card {
    padding: 0;
  }
  width: 100%;
  height: 185px;
  background: #f9fafb;
  display: flex;

  .help-list {
    margin: 0 auto;
    width: 1200px;

    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
    .help-box {
      img {
        margin-right: 30px;
      }
      .title {
        font-size: 18px;
        font-weight: 500;
        color: #333333;
        line-height: 25px;
        margin-bottom: 10px;
      }
      cursor: pointer;
      padding: 15px 20px;
      width: 248px;
      height: 82px;
      background: #ffffff;
      // box-shadow: 0px 2px 10px 0px #e1e1e1;
      border-radius: 6px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
    }
  }
}
</style>
